import { render, staticRenderFns } from "./ContentPages.vue?vue&type=template&id=61e0d5c4&scoped=true&"
import script from "./ContentPages.vue?vue&type=script&lang=js&"
export * from "./ContentPages.vue?vue&type=script&lang=js&"
import style0 from "./ContentPages.vue?vue&type=style&index=0&id=61e0d5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0d5c4",
  null
  
)

export default component.exports